import {Component} from 'react';
import styles from './Dialog.module.scss';
import i18n from "../i18n";
import {Button} from "@material-ui/core";
import type { ModalChildProps } from './ModalComponent';

export interface DialogProps extends ModalChildProps {
    closeHandler: () => void;
    dialogText: string;
    acceptText?: string;
    cancelHandler?: () => void;
    cancelText?: string;
}

export class Dialog extends Component<DialogProps> {
    constructor(props: DialogProps) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose(): void {
        this.props.closeHandler();
    }

    render() {
        return <div className={styles.dialog} >
            <div className={styles.message}>
                { this.props.dialogText }
            </div>
            <Button
                className={styles.button}
                variant="contained"
                color="primary"
                onClick={this.handleClose}
            >{ this.props.acceptText ? this.props.acceptText : i18n.t('dialog.accept') }</Button>
            { this.props.cancelHandler ?
            <Button
                className={styles.button}
                variant="outlined"
                color="default"
                onClick={this.props.cancelHandler}
                >{this.props.cancelText ? this.props.cancelText : i18n.t('dialog.cancel')}</Button>
                : null
            }
        </div>
    }
}
